var exports = {
  "iE": "xaf9ae18d--315aad--wrapper",
  "dg": "xaf9ae18d--315aad--wrapper--redesign",
  "o9": "xaf9ae18d--315aad--wrapper--cluster",
  "zx": "xaf9ae18d--315aad--point",
  "Eu": "xaf9ae18d--315aad--point--residential-complex",
  "dr": "xaf9ae18d--315aad--point--cluster",
  "BT": "xaf9ae18d--315aad--point--posutochno",
  "J8": "xaf9ae18d--315aad--posutochno_wrapper",
  "ag": "xaf9ae18d--315aad--balloon",
  "nZ": "xaf9ae18d--315aad--balloon--redesign",
  "HP": "xaf9ae18d--315aad--balloon--hovered",
  "q9": "xaf9ae18d--315aad--price",
  "Kk": "xaf9ae18d--315aad--icon",
  "U9": "xaf9ae18d--315aad--count",
  "KF": "xaf9ae18d--315aad--promotion",
  "lq": "xaf9ae18d--315aad--viewed",
  "vu": "xaf9ae18d--315aad--active",
  "ck": "xaf9ae18d--315aad--colorized",
  "MP": "xaf9ae18d--315aad--residential-complex",
  "W0": "xaf9ae18d--315aad--balloon--redesign-v2",
  "tu": "xaf9ae18d--315aad--posutochno_balloon",
  "Cx": "xaf9ae18d--315aad--newbuilding--main",
  "ZG": "xaf9ae18d--315aad--balloon--viewed-single",
};

module.exports = exports;
